import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { GoogleLogin } from '@react-oauth/google';
import './Navbar.css';

const Navbar: React.FC = () => {
  const { user, logout, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [showDropdown, setShowDropdown] = useState(false);

  // Handle logout
  const handleLogout = () => {
    logout();
    navigate('/');
  };

  // Toggle dropdown menu
  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  // Close dropdown when clicking outside
  const closeDropdown = () => {
    setShowDropdown(false);
  };

  // Generate initials from email
  const getInitials = (email: string | undefined) => {
    if (!email) return '?';
    const parts = email.split('@');
    if (parts.length === 0) return '?';
    
    const name = parts[0];
    if (name.length === 0) return '?';
    
    return name.charAt(0).toUpperCase();
  };

  return (
    <nav className="navbar">
      {/* Logo/Brand */}
      <div className="navbar-brand">
        <span onClick={() => navigate('/')} className="navbar-logo">
          DailyAiBriefing
        </span>
      </div>

      {/* Profile and Logout or Sign In */}
      <div className="navbar-profile">
        {isAuthenticated ? (
          // Authenticated User View
          <div 
            className="profile-dropdown-toggle"
            onClick={toggleDropdown}
          >
            {/* Profile Avatar */}
            <div className="profile-avatar">
              {getInitials(user?.email)}
            </div>
            
            {/* Email */}
            <div className="profile-email">
              {user?.email}
            </div>
            
            {/* Dropdown Arrow */}
            <div className="dropdown-arrow">
              ▼
            </div>
            
            {/* Dropdown Menu */}
            {showDropdown && (
              <div>
                {/* Invisible overlay to detect clicks outside */}
                <div 
                  className="dropdown-overlay"
                  onClick={closeDropdown}
                />
                
                <div className="dropdown-menu">
                  {/* Profile Section */}
                  <div className="dropdown-profile-section">
                    <div className="dropdown-username">
                      {user?.email?.split('@')[0]}
                    </div>
                    <div className="dropdown-email">
                      {user?.email}
                    </div>
                  </div>
                  
                  {/* Menu Items */}
                  <div className="dropdown-menu-items">
                    <div 
                      className="dropdown-menu-item"
                      onClick={() => {
                        navigate('/dashboard');
                        closeDropdown();
                      }}
                    >
                      Dashboard
                    </div>
                    
                    <div 
                      className="dropdown-menu-item dropdown-menu-item-logout"
                      onClick={handleLogout}
                    >
                      Sign Out
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        ) : (
          // Unauthenticated User View
          <div className="navbar-auth">
            <GoogleLogin
              onSuccess={credentialResponse => {
                // We'll handle this in the LandingPage component
                console.log('Login clicked in navbar');
              }}
              onError={() => {
                console.error('Navbar login failed');
              }}
              useOneTap={false}
              type="standard"
              theme="outline"
              size="large"
              text="signin_with"
              shape="rectangular"
            />
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar; 